<rt-dialog-header [heading]="'tlc.assign_members_to_jobs.dialog.heading' | translate">
  <div class="invited-members-container">
    @for (member of members; track member.email) {
      <tlc-member-avatar [member]="member!" />
    }
  </div>
</rt-dialog-header>
<rt-dialog-body layout-vertical>
  @if (members.length > 1) {
    <rt-infobox
      class="members-count"
      type="information"
      [heading]="
        'tlc.assign_members_to_jobs.dialog.jobs.infobox.heading'
          | translate: { count: members.length }
      "
      [subheading]="'tlc.assign_members_to_jobs.dialog.jobs.infobox.subheading' | translate"
      iconName="info-outline"
      [isDismissible]="false"
      [hasDotDivider]="false"
    />
  }
  <form [formGroup]="$any(form)">
    <div class="section-container jobs" margin-bottom-large>
      <div class="heading-container">
        <span class="heading">
          {{ 'tlc.assign_members_to_jobs.dialog.jobs.heading' | translate }}
        </span>
        <rt-badge color="optional" [text]="'tlc.common.optional' | translate" />
      </div>
      <span
        class="subheading"
        [innerHTML]="'tlc.assign_members_to_jobs.dialog.jobs.subheading' | translate"
      ></span>
      <tlc-hiring-resource-select
        [resourceKind]="HiringResourceKind.Job"
        [control]="form.controls.jobsSelect"
        [items]="jobsItems()"
        [itemsLoading]="!jobsLoaded()"
        [placeholder]="'tlc.assign_members_to_jobs.dialog.jobs.select_placeholder' | translate"
      />
    </div>
    <div class="section-container talent-pools">
      <div class="heading-container">
        <span class="heading">
          {{ 'tlc.assign_members_to_jobs.dialog.talent_pools.heading' | translate }}
        </span>
        <rt-badge color="optional" [text]="'tlc.common.optional' | translate" />
      </div>
      <span
        class="subheading"
        [innerHTML]="'tlc.assign_members_to_jobs.dialog.talent_pools.subheading' | translate"
      ></span>
      <tlc-hiring-resource-select
        [resourceKind]="HiringResourceKind.TalentPool"
        [control]="form.controls.talentPoolsSelect"
        [items]="talentPoolsItems()"
        [itemsLoading]="!talentPoolsLoaded()"
        [placeholder]="
          'tlc.assign_members_to_jobs.dialog.talent_pools.select_placeholder' | translate
        "
      />
    </div>
  </form>
</rt-dialog-body>

<rt-dialog-footer>
  <rt-button (click)="confirm()" [loading]="loading()" variant="primary"
    >{{ 'tlc.assign_members_to_jobs.dialog.confirm' | translate }}
  </rt-button>
</rt-dialog-footer>
